import { axios } from '@/services/axios';

/**
 * Removes the trunk from a list of platform numbers in one request. Normal
 * deallocation requirements still apply on the server.
 */
const deallocatePlatformNumbersTrunk = async ({
    platformId,
    numberIds,
    scope,
}) => {
    const res = await axios.post(
        `/PlatformNumbers/Process/${platformId}/DeallocateTrunk`,
        numberIds,
        {
            headers: {
                'X-RequestScope': scope,
            },
        },
    );
    return res.data;
};

export default deallocatePlatformNumbersTrunk;
